module.exports = __webpack_public_path__ + "img/1360493241.b4b05364.jpg";